export default "__VITE_ASSET__CANc1Szi__"